<template>
  <!-- <section class="content"> -->
  <div>
    <!-- <Toast style="margin-top: 35px" /> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid">
        <div class="p-col">
          <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
        </div>
      </div>
      <Dialog header="Item Master" :modal="true" :visible.sync="displayBasic"
              :style="{width: '50vw'}" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label for="name">Name <span style="color:red">*</span></label>
            <InputText v-model.trim="name" id="name"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="code">Code<span style="color:red">*</span></label>
            <InputText v-model.trim="code" id="code"/>
          </div>
    
          <div class="p-field p-col-12 p-md-2">
            <label for="unit">Unit<span style="color:red">*</span></label>
            <Dropdown v-model="selectedUnitId" :options="unitLists" id="unit"
                      optionLabel="shortName" :filter="true" placeholder="Select Unit" :showClear="true"/>
          </div>
          
          <div class="p-field p-col-12 p-md-1 align-self-end">
            <unitDialog v-tooltip.top="'Add Unit'" @set_data_unit="set_data_unit"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="code">Hs Code<span style="color:red"></span></label>
            <InputText v-model.trim="hsCode" id="hsCode"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="vat">Tax Type</label>
            <select class="selectBox" v-model="selectedVatType">
              <option selected disabled value="">Select Tax Type</option>
              <option v-for="(type,ind) in vatTypeList" :key="ind">{{ type.vatType }}</option>
            </select>
          </div>
          <div class="p-field p-col-12 p-md-5">
            <label for="group">Group<span style="color:red">*</span></label>
            <Dropdown v-model="selectedItemGroup" :options="itemGroupLists" id="group" optionLabel="name" :filter="true"
                      placeholder="Select Group" @change="selectItemSubgroup(selectedItemGroup.id)" :showClear="true"/>
          </div>
          <div class="p-field p-col-12 p-md-1 align-self-end">
            <itemGroupDialog v-tooltip.top="'Add Item Group'" @set_data="set_data"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="subGroup">Sub Group</label>
            <Dropdown v-model="selectedItemSubGroup" :options="itemSubGroupLists" id="subGroup" optionLabel="name"
                      :filter="true" placeholder="Select Sub Group" :showClear="true"/>
          </div>
          <div class="p-field p-col-12 p-md-6" v-if="isChildOrg">
            <label for="parentItem">Parent Item</label>
            <Dropdown 
              v-model="selectedParentItem"
              :options="parentItemLists"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Parent Item"
              :showClear="true"
              :filter="true"
            />
          </div>
          <div class="p-field p-col-12 p-md-6 align-self-end">
            <div class="btnWrapper">
              <div class="btnItm">
                <itemSubGroupDialog v-tooltip.top="'Add Item Sub Group'" @set_data_subGroup="set_data_subGroup"/>
              </div>
              <div class="btnItm">
                <Button label="Rate Info" @click.prevent="openBasicRate" class="p-button-info btn-btm-0 width-auto p-button"/>
              </div>
              <div class="btnItm">
                <Button label="Opening Details" @click.prevent="openOpening" class="p-button-secondary btn-btm-0 width-auto p-button"/>
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-6">

          <Button id="imageUpload" @click.prevent="showItemUpload" class="p-button-raised"
                    label="Upload Image"/>
          </div>
          <div class="p-field p-col-12 p-md-6">
  
            <Button :disabled="!this.imageList.length >0" id="viewImage" @click.prevent="viewImage" label="View Image"
                    class="p-button-raised"/>
          </div>


          <div class="p-field p-col-12 p-md-3 align-self-center">
            <label>Status</label>
            <div class="radiobox">
              <div class="radiobox-itm">
                <RadioButton id="active" name="ACTIVE" value="ACTIVE" v-model="status"/>
                <label for="active">Active</label>
              </div>
              <div class="radiobox-itm">
                <RadioButton id="inactive" name="INACTIVE" value="INACTIVE" v-model="status"/>
                <label for="inactive">Inactive</label>
              </div>
            </div>
          </div>
  
          <div class="p-field p-col-12 p-md-2 align-self-center">
            <div class="radiobox">
              <div class="radiobox-itm">
                <Checkbox id="binary" v-model="serviceType" :binary="true"/>
                <label for="binary">Is Service Item</label>
              </div>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-2 align-self-center">
            <div class="radiobox">
              <div class="radiobox-itm">
                <Checkbox id="multiUnit" v-model="isMultiUnit" :binary="true"/>
                <label for="multiUnit">Multi Unit</label>
              </div>
            </div>
          </div>
           <div class="p-field p-col-12 p-md-2">
            <label for="code">Bar Code<span style="color:red"></span></label>
            <InputText v-model="qrCode" id="qrCode"/>
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label for="description">Description</label>
            <Textarea id="description" rows="4" cols="25" v-model="description"/>
          </div>
               <!-- <div class="p-field p-col-12 p-md-3">
            <label for="code">Bar Code<span style="color:red"></span></label>
            <InputText v-model="qrCode" id="qrCode"/>
          </div> -->
          <div class="p-field p-col-12 p-md-6" v-if="isMultiUnit">
            <Dropdown v-show="isMultiUnit" v-model="multiUnitList" :options="unitConversionLists"
                         optionLabel="name" @change="addUnitConversionFromList"
                         :filter="true" placeholder="Select Unit Conversion" class="p-dropdown mt-25" :showClear="true"/>
            <DataTable
              :value="unitConversionData"
              editMode="cell" class="editable-cells-table mt-25"
            >
              <Column header="Unit From" field="unitFrom">
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="unitLists" optionLabel="name"
                            placeholder="Select Unit">
                  </Dropdown>
                  
                </template>
              </Column>
              <Column header="From Qty" field="unitFromValue">
                <template #editor="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>
              </Column>
              <Column header="Unit To" field="unitTo" filterField="unitTo">
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="unitLists" optionLabel="name"
                            placeholder="Select Unit">
                  </Dropdown>
                </template>
              </Column>
              <Column header="To Qty" field="unitToValue" filterField="unitToValue">
                <template #editor="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>
              </Column>
              <Column header="Action">
                <template>
                  <Button class="p-button-danger" icon="pi pi-times"
                          @click.prevent="deleteUnitConversion(index)"/>
                </template>
              </Column>
              <template #footer>
                <Button class="p-button-info addNewBtn btn-btm-0 width-auto p-button" icon="pi pi-plus" label="New" @click.prevent="addUnitConversion"/>
              </template>
            </DataTable>
          </div>

        </div>
        <Dialog header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}">
          <input id="imageUpload" type="file" style="margin-bottom: 2em;" @change="onFileSelect" multiple/>
          <Carousel :value="url" :numVisible="2" :numScroll="2">
            <template #item="slotProps">
              <div class="product-item">
                <div class="product-item-content">
                  <div class="p-mb-3">
                    <img :src="slotProps.data" style="height:250px;width:250px" class="product-image"/>
                  </div>
                  <div>
                    <div class="car-buttons p-mt-5">
                      <Button class="p-button-raised  p-button-danger p-mr-2"
                              @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Carousel>
          <template #footer>
            <Button class="p-button-raised  " @click.prevent="cancelImageUpload"
                    label="Upload"/>
          </template>
        </Dialog>
        <!-- Image Upload Dialog -->

        <Dialog header="View Image " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
          <div v-if="this.imageList.length > 0">
            <div class="card">
              <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps">
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="slotProps.data.name" style="height:250px;width:250px" class="product-image"/>
                      </div>
                      <div>
                        <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised  p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Carousel>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised  p-button-danger" @click.prevent="back" label="Back"/>
          </template>
        </Dialog>
        <template #footer>
          <Button class="p-button-raised " @click.prevent="addItemMaster"
                  :label="editing==true?'Update':'Add'"/>
          <Button class="p-button-raised  p-button-info" @click.prevent="addAndNewItemMaster"
                  v-if="!editing" label="Add & New"/>
          <Button @click.prevent="cancel" class="p-button-raised  p-button-danger" label="Cancel"/>
        </template>
      </Dialog>
    </form>
    <Dialog header="Rate Info" :modal="true" :closable=false
            :visible.sync="displayBasicRate" :style="{width: '50vw'}">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="mrp">MRP</label>
          <InputNumber id="mrp" v-model="mrp" onfocus="if (this.value === '0.00') this.value = ''"
                       :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label for="purchaseRate">Purchase Rate</label>
          <InputNumber id="purchaseRate" v-model="purchaseRate" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="salesRate">Sales Rate</label>
          <InputNumber id="salesRate" v-model="salesRate" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>

        <div class="p-field p-col-12 p-md-6" v-if="this.$store.getters.modules.includes('5.32')">
          <label for="minimumSalesRate">Minimum Sales Rate</label>
          <InputNumber id="minimumSalesRate" v-model="minimumSalesRate" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>

        <div class="p-field p-col-12 p-md-6">
          <label for="wholesaleRate">Wholesale Rate</label>
          <InputNumber id="wholesaleRate" v-model="wholesaleRate" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="discount">Discount Percentage</label>
          <InputNumber id="discount" v-model="discount" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="salesMargin">Margin Percentage</label>
          <InputNumber id="salesMargin" v-model="salesMargin" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
      </div>
      <template #footer>
        <Button class="p-button-raised " v-if="!displayBasicView" @click.prevent="closeBasicRate" label="Save"/>
        <Button @click.prevent="closeBasicRate"   :label="displayBasicView ? 'Back':'Cancel'"
                class="p-button-raised  p-button-danger"/>
      </template>
    </Dialog>

    <Dialog header="Opening Details" :modal="true" :closable=false
            :visible.sync="displayOpeningDialog" :style="{width: '50vw'}">

      <div v-if="!displayBasicView" class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="warehouse">Store</label>
          <Dropdown v-model="warehouse" :options="warehouseLists" optionLabel="name" id="warehouse"
                    :filter="true" placeholder="Select store" :showClear="true"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="mrp">Quantity</label>
          <InputNumber id="openingQty" v-model="openingQty" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="purchaseRate">Rate</label>
          <InputNumber id="openingRate" v-model="openingRate" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="salesRate">Amount</label>
          <InputNumber
            id="openingAmount" v-model="openingAmount" onfocus="if (this.value === '0.00'){this.value = ''
}" :minFractionDigits="2" :maxFracionDigits="4"/>
          <div style="display:none">
            {{ openingAmt }}
            {{ openingRates }}
            {{ marginPercent }}
          </div>
        </div>
      </div>

      <div v-if="!displayBasicView" class="p-field p-col-12 p-md-6 p-offset-3">
        <Button class="p-button-raised " @click.prevent="addOpeningDetails"
                :label="editDetails ? 'Update':'Save'"/>
      </div>
      <DataTable :value="warehouseDTOList" class="p-datatable-responsive p-datatable-customers"
                 style="margin-top:10px;">
        <Column header="Warehouse">
          <template #body="slotProps">
            {{ !this.editing ? slotProps.data.name : slotProps.data.name }}
          </template>
        </Column>
        <Column header="Quantity" field="openingStock"></Column>
        <Column header="Rate" field="openingRate"></Column>
        <Column header="Amount">
          <template #body="slotProps">
            {{ slotProps.data.openingRate * slotProps.data.openingStock }}
          </template>
        </Column>
        <Column v-if="!displayBasicView" header="Action">
          <template #body="slotProps">
            <Button class=" p-button-raised p-button-sm p-button-success"
                    @click.prevent="editOpeningDetails(slotProps.data,slotProps.index)" icon="pi pi-pencil"/>
            <Button icon="pi pi-trash" class=" p-button-raised p-button-sm p-button-danger"
                    v-if="editDetails" @click="deleteOpeningdetails(slotProps.data, slotProps.data.index)" disabled/>
            <Button icon="pi pi-trash" class=" p-button-raised p-button-sm p-button-danger"
                    v-else-if="!editDetails" @click="deleteOpeningdetails(slotProps.data, slotProps.data.index)"/>
          </template>
        </Column>
      </DataTable>
      <template #footer>
        <Button class=" p-button-raised" @click.prevent="backOpening" v-if="!displayBasicView" label="Save"/>
        <Button @click.prevent="openingCancel" class=" p-button-raised p-button-danger" :label="displayBasicView ? 'Back':'Cancel'" />
      </template>
    </Dialog>

    <Dialog header="Item Master View" :modal="true" :visible.sync="displayBasicView"
              :style="{width: '60vw'}" :closable=false :contentStyle="{'overflow': 'auto'}">
        <div class="p-fluid p-formgrid p-grid">

          <div class="p-field p-col-12 p-md-3">
            <label for="name" style="font-weight: bold">Name: <span style="color:red;"></span></label>
            <label>{{name}}</label>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="code" style="font-weight: bold">Code: <span style="color:red;"></span></label>
            <label>{{code}}</label>
          </div>
    
          <div class="p-field p-col-12 p-md-3">
            <label for="unit" style="font-weight: bold">Unit: <span style="color:red;"></span></label>
                      <label>{{unit}}</label>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="vat" style="font-weight: bold">Tax Type: </label>
            <label>{{code}}</label>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="group" style="font-weight: bold">Group: <span style="color:red;"></span></label>
                      <label>{{selectedItemGroup.name}}</label>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="subGroup" style="font-weight: bold">Sub Group: </label>
                      <label>{{selectItemSubgroup.name}}</label>
          </div>
          
          <div class="p-field p-col-12 p-md-3">
            <label for="unit"></label>
            <Button label="Rate Info" @click.prevent="openBasicRate" class=" p-button-raised"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="unit"></label>
            <Button label="Opening Details" @click.prevent="openOpening" class=" p-button-raised"/>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <Button id="viewImage" @click.prevent="viewImage" label="View Image"
                    class=" p-button-raised"/>
          </div>

          <div class="p-field p-col-12 p-md-6">
            <label style="font-weight: bold">Status: </label>
            <div class="p-field p-col-12 p-md-6">
              <RadioButton id="active" name="ACTIVE" value="ACTIVE" v-model="status"/>
              <label for="active">Active</label>
              <RadioButton id="inactive" name="INACTIVE" value="INACTIVE" v-model="status"/>
              <label for="inactive">Inactive</label>
            </div>
          </div>


          <div class="p-field p-col-12 p-md-3">
            <Checkbox id="binary" v-model="serviceType" :binary="true"/>
            <label for="binary" style="font-weight: bold">Is Service Item: </label>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="multiUnit" style="font-weight: bold">Multi Unit: </label>

            <div class="p-field p-col-12 p-md-3">
              <Checkbox id="multiUnit" v-model="isMultiUnit" :binary="true"/>
            </div>

            <MultiSelect v-show="isMultiUnit" v-model="multiUnitList" :options="unitConversionLists"
                         optionLabel="name" @change="addUnitConversionFromList"
                         :filter="true" placeholder="Select Unit Conversion" :showClear="true"/>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="description" style="font-weight: bold">Description: </label>
            <Textarea id="description" rows="4" cols="25" disable="true" v-model="description"/>
          </div>

          <div class="p-field p-col-12 p-md-3">
            <label for="code" style="font-weight: bold">Bar Code: <span style="color:red"></span></label>
            <label>{{qrCode}}</label>
          </div>

          <div class="p-field p-col-12 p-md-9" v-if="isMultiUnit">
            <DataTable
              :value="unitConversionData"
              editMode="cell" class="editable-cells-table"
            >
              <Column header="Unit From" field="unitFrom">
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="unitLists" optionLabel="name"
                            placeholder="Select Unit">
                  </Dropdown>
                </template>
              </Column>
              <Column header="From Qty" field="unitFromValue">
                <template #editor="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>
              </Column>
              <Column header="Unit To" field="unitTo" filterField="unitTo">
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data[slotProps.column.field]" :options="unitLists" optionLabel="name"
                            placeholder="Select Unit">
                  </Dropdown>
                </template>
              </Column>
              <Column header="To Qty" field="unitToValue" filterField="unitToValue">
                <template #editor="slotProps">
                  <InputNumber v-model="slotProps.data[slotProps.column.field]" :minFractionDigits="2"
                               :maxFracionDigits="4"/>
                </template>
              </Column>
              <Column header="Action">
                <template>
                  <Button class="p-button-danger" icon="pi pi-times"
                          @click.prevent="deleteUnitConversion(index)"/>
                </template>
              </Column>
              <template #footer>
                <Button class="p-button-success" icon="pi pi-plus" @click.prevent="addUnitConversion"/>
              </template>
            </DataTable>
          </div>

        </div>
        <Dialog header="Item Image Upload" :modal="true" :visible.sync="showItemUploadDialog" :style="{width:'50vw'}">
          <input id="imageUpload" type="file" style="margin-bottom: 2em;" @change="onFileSelect" multiple/>
          <Carousel :value="url" :numVisible="2" :numScroll="2">
            <template #item="slotProps">
              <div class="product-item">
                <div class="product-item-content">
                  <div class="p-mb-3">
                    <img :src="slotProps.data" style="height:250px;width:250px" class="product-image"/>
                  </div>
                  <div>
                    <div class="car-buttons p-mt-5">
                      <Button class="p-button-raised  p-button-danger p-mr-2"
                              @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Carousel>
          <template #footer>
            <Button class="p-button-raised  " @click.prevent="cancelImageUpload"
                    label="Upload"/>
          </template>
        </Dialog>
        <!-- Image Upload Dialog -->

        <Dialog header="View Image " :modal="true"
                :visible.sync="openImageViewer" :style="{width: '50vw'}">
          <div v-if="this.imageList.length > 0">
            <div class="card">
              <Carousel :value="imageList" :numVisible="2" :numScroll="2">
                <template #item="slotProps">
                  <div class="product-item">
                    <div class="product-item-content">
                      <div class="p-mb-3">
                        <img :src="slotProps.data.name" style="height:250px;width:250px" class="product-image"/>
                      </div>
                      <div>
                        <div class="car-buttons p-mt-5">
                          <Button class="p-button-raised  p-button-danger"
                                  @click.prevent="removeImage(slotProps.data,slotProps)" label="Remove"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Carousel>
            </div>
          </div>
          <template #footer>
            <Button class="p-button-raised  p-button-danger" @click.prevent="back" label="Back"/>
          </template>
        </Dialog>
        <template #footer>
          <!-- <Button class="p-button-raised " @click.prevent="addItemMaster"
                  :label="editing==true?'Update':'Add'"/>
          <Button class="p-button-raised  p-button-info" @click.prevent="addAndNewItemMaster"
                  v-if="!editing" label="Add & New"/> -->
          <Button @click.prevent="cancel" class="p-button-raised  p-button-danger" label="Back"/>
        </template>
      </Dialog>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import InputNumber from 'primevue/inputnumber'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import itemGroupDialog from './itemGroupDialog.vue'
import itemSubGroupDialog from './itemSubGroupDialog.vue'
import unitDialog from './measurementUnitDialog.vue'
import Carousel from 'primevue/carousel'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import MultiSelect from 'primevue/multiselect'

export default {
  name: 'itemMaster',
  props: ['item'],
  data() {
    return {
      name: '',
      qrCode: '',
      selectedItemGroup: '',
      selectedUnitId: '',
      code: '',
      hsCode: '',
      selectedVatType: '',
      selectedItemSubGroup: '',
      salesRate: 0,
      minimumSalesRate: 0,
      mrp: 0,
      purchaseRate: 0,
      salesMargin: 0,
      warehouse: 0,
      openingQty: 0,
      openingRate: 0,
      openingAmount: 0,
      wholesaleRate: 0,
      status: 'ACTIVE',
      description: '',
      discount: 0,
      multiUnitList: [],
      unitConversionData: [],
      vatTypeList: [
        {'vatType': 'Exclusive'},
        // {'vatType': 'Inclusive'},
        {'vatType': 'Exempt'}
      ],
      displayBasicRate: false,
      displayOpeningDialog: false,
      openImageViewer: false,
      displayBasic: false,
      displayBasicView: false,
      bonusItem: false,
      serviceType: false,
      selectedParentItem: null,
      parentItemLists: [],
      parentOrgId: null,
      isChildOrg: false,
      ccPercentage: 0.00,
      position: 'center',
      editing: false,
      id: null,
      loading: false,
      images: [],
      reacitemSubGroupLists: [],
      itemSubGroupLists: [],
      warehouseDTOList: [],
      editDetails: false,
      index: null,
      url: [],
      deletedImage: [],
      imageList: [],
      showItemUploadDialog: false,
      isMultiUnit: false
    }
  },
  computed: {
    unitLists() {
      return this.$store.state.itemgroup.measurementUnitLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    unitConversionLists() {
      return this.$store.state.itemgroup.unitConversionLists
    },
    itemCodeNo() {
      return this.$store.state.itemMaster.itemCodeNo
    },
    itemGroupLists() {
      return this.$store.state.itemgroup.itemGroupLists
    },
    openingAmt() {
      let openingAmount = 0
      openingAmount = parseFloat(this.openingQty) * parseFloat(this.openingRate)
      if (isNaN(openingAmount)) {
        openingAmount = 0
      }
      this.openingAmount = openingAmount
      return openingAmount
    },
    openingRates() {
      let openingRate = 0
      openingRate = parseFloat(this.openingAmount) / parseFloat(this.openingQty)
      if (isNaN(openingRate)) {
        openingRate = 0
      }
      this.openingRate = openingRate
      return openingRate
    },
    marginPercent() {
      let marginPercent = 0
      marginPercent = (parseFloat(this.salesRate) - parseFloat(this.purchaseRate)) / parseFloat(this.purchaseRate) * 100
      if (isNaN(marginPercent)) {
        marginPercent = 0
      }
      this.salesMargin = marginPercent
      return marginPercent
    }
  },
  async mounted() {
    await this.checkOrganizationType()
    if (this.parentOrgId !== 0) {
      await this.loadParentItems()
    }
    this.unitList()
    this.itemSubGroupList()
    this.itemGroupList()
    if (this.item === undefined) {
      this.maxItemCodeNo()
    }
    this.warehouseList()
    this.resetOpeningDetails()
    this.findUnitConversionList()
  },
  methods: {
    async checkOrganizationType() {
      try {
        const org = await this.$store.dispatch('loadOrganisation')
        this.isChildOrg = !!org.data.data.parentId
        this.parentOrgId = org.data.data.parentId
      } catch (error) {
        console.error('Error fetching organization:', error)
      }
    },
    async loadParentItems() {
      try {
        const response = await this.$store.dispatch('loadItemMasterListChild', this.parentOrgId)
        this.parentItemLists = response.data.data.map(item => ({
          id: item.id,
          name: item.name,
          groupName: item.groupName
        }))
      } catch (error) {
        console.error('Error loading parent items:', error)
      }
    },
    async findUnitConversionList() {
      await this.$store.dispatch('loadUnitConversionList')
    },
    async addItemMaster() {
      let response = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item name cannot be empty!', life: 10000})
        return
      }
      if (this.code === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item code cannot be empty!', life: 10000})
        return
      }
      if (this.selectedUnitId === '' || this.selectedUnitId === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select measurement unit!', life: 10000})
        return
      }
      if (this.selectedVatType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Vat Type!', life: 10000})
        return
      }
      if (this.selectedItemGroup === '' || this.selectedItemGroup === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select item group!', life: 10000})
        return
      }
      if (this.qrCode === '') {
        this.qrCode = this.name + '-' + this.code + '-' + this.salesRate
      }
      const parentID = this.selectedParentItem ? this.selectedParentItem : null
      let itemMaster = {
        parentID: parentID,
        name: this.name,
        itemCode: this.code,
        itemGroup: this.selectedItemGroup.id,
        itemSubGroup: this.selectedItemSubGroup.id,
        measurement: this.selectedUnitId.id,
        vatType: this.selectedVatType,
        salesRate: this.salesRate,
        minimumSalesRate: this.minimumSalesRate,
        mrp: this.mrp,
        purchaseRate: this.purchaseRate,
        salesMarginPercentage: this.salesMargin,
        discountPercentage: this.discount,
        openingStock: this.openingQty,
        openingRate: this.openingRate,
        id: this.id,
        status: this.status,
        wholesaleRate: this.wholesaleRate,
        warehouseDTOList: this.warehouseDTOList,
        description: this.description,
        deletedImage: this.deletedImage,
        bonusItem: this.bonusItem,
        serviceType: this.serviceType,
        ccPercentage: this.ccPercentage,
        fullQrCode: this.qrCode,
        itemMultiUnitDetailsDTOList: this.unitConversionData,
        multiUnit: this.isMultiUnit,
        hsCode: this.hsCode
      }
      const formData = new FormData()
      formData.append('itemMaster', JSON.stringify(itemMaster))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      if (!this.editing) {
        this.loading = !this.loading
        response = await this.$store.dispatch('createItemMaster', formData)
        this.$emit('set_data_item', response.data.data)
        this.loading = false
      } else {
        this.loading = !this.loading
        response = await this.$store.dispatch('updateItemMaster', formData)
        this.loading = false
      }
      this.responseMessage(response)
      this.closeBasic()
      this.selectedParentItem = null
      await this.maxItemCodeNo()
    },
    async addAndNewItemMaster() {
      let response = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item name cannot be empty!', life: 10000})
        return
      }
      if (this.code === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Item code cannot be empty!', life: 10000})
        return
      }
      if (this.selectedUnitId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select measurement unit!', life: 10000})
        return
      }
      if (this.selectedVatType === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select Vat Type!', life: 10000})
        return
      }
      if (this.selectedItemGroup === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select item group!', life: 10000})
        return
      }
      if (this.qrCode === '') {
        this.qrCode = this.name + '-' + this.code + '-' + this.salesRate
      }
      let itemMaster = {
        parentID: this.selectedParentItem ? this.selectedParentItem : null,
        name: this.name,
        itemCode: this.code,
        itemGroup: this.selectedItemGroup.id,
        itemSubGroup: this.selectedItemSubGroup.id,
        measurement: this.selectedUnitId.id,
        vatType: this.selectedVatType,
        salesRate: this.salesRate,
        minimumSalesRate: this.minimumSalesRate,
        mrp: this.mrp,
        purchaseRate: this.purchaseRate,
        salesMarginPercentage: this.salesMargin,
        discountPercentage: this.discount,
        openingStock: this.openingQty,
        openingRate: this.openingRate,
        id: this.id,
        status: this.status,
        wholesaleRate: this.wholesaleRate,
        warehouseDTOList: this.warehouseDTOList,
        description: this.description,
        deletedImage: this.deletedImage,
        fullQrCode: this.qrCode,
        bonusItem: this.bonusItem,
        serviceType: this.serviceType,
        ccPercentage: this.ccPercentage,
        multiUnit: this.isMultiUnit,
        itemMultiUnitDetailsDTOList: this.unitConversionData,
        hsCode: this.hsCode
      }
      const formData = new FormData()
      formData.append('itemMaster', JSON.stringify(itemMaster))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      this.loading = !this.loading
      response = await this.$store.dispatch('createItemMaster', formData)
      this.loading = false
      this.selectedParentItem = null
      this.responseMessage(response)
      await this.maxItemCodeNo()
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        let fileExtension = f.name.split('.').pop()
        if (fileExtension !== 'jpg' && fileExtension !== 'jpeg' && fileExtension !== 'png' && fileExtension !== 'JPG') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Please select Valid Image!', life: 10000})
          return
        }
        if (f.size > (500 * 1024)) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Image file size  must be less then 500 KB!', life: 10000})
          return
        }
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
          // console.log(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    viewImage() {
      this.openImageViewer = true
    },
    back() {
      this.openImageViewer = false
    },
    removeImage(data, props) {
      if (data.id !== undefined && data !== null) {
        this.deletedImage.push(data.id)
      }
      this.url.splice(props.index, 1)
      this.imageList.splice(props.index, 1)
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: 'Item' + response.data.message, life: 10000})
        this.reset()
        this.resetRateInfo()
        return
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      }
    },
    async maxItemCodeNo() {
      let response = await this.$store.dispatch('maxItemCodeNo')
      if (this.item === undefined) {
        if (response.data.data === null) {
          this.code = ''
        } else {
          this.code = response.data.data
        }
      } else {
        this.code
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async unitList() {
      await this.$store.dispatch('loadMeasurementList')
    },
    async itemSubGroupList() {
      let resp = await this.$store.dispatch('itemSubGroupDropDown')
      this.itemSubGroupLists = resp.data.data
      this.reacitemSubGroupLists = resp.data.data
    },
    async itemGroupList() {
      await this.$store.dispatch('itemGroupDropDown')
    },
    set_data(data) {
      this.selectedItemGroup = data
    },
    set_data_subGroup(data) {
      this.selectItemSubgroup = data
    },
    set_data_unit(data) {
      this.selectedUnitId = data
    },
    cancel() {
      this.itemSubGroupLists = this.reacitemSubGroupLists
      this.reset()
      this.resetRateInfo()
      this.editing = false
      this.displayBasic = false
      this.displayBasicRate = false
      this.displayBasicView = false
      this.displayOpeningDialog = false
      this.images = []
      this.url = []
      this.warehouseDTOList = []
    },
    cancelImageUpload() {
      this.url = []
      this.showItemUploadDialog = false
    },
    selectItemSubgroup(id) {
      let filteredSubGroup = 0
      if (this.itemSubGroupLists.length === 0 || filteredSubGroup === 0) {
        this.itemSubGroupLists = this.reacitemSubGroupLists
      }
      filteredSubGroup = this.itemSubGroupLists.filter(subGroup => subGroup.itemGroupId.id === id)
      this.itemSubGroupLists = filteredSubGroup
    },
    rateInfoCancel() {
      if (!this.editing) {
        this.salesRate = ''
        this.minimumSalesRate = 0
        this.purchaseRate = ''
        this.mrp = ''
      }
      this.displayBasicRate = false
      this.displayBasic = true
    },
    openingCancel() {
      this.resetOpeningDetails()
      if (!this.displayBasicView) {
        this.displayBasic = true
      } else {
        this.displayBasic = false
      }
      this.displayOpeningDialog = false
      this.displayBasicRate = false
    },
    backOpening() {
      this.displayOpeningDialog = false
      this.displayBasic = true
    },
    editIemMaster(data) {
      this.editing = true
      this.name = data.name
      this.code = data.itemCode
      if (data.itemGroupId === undefined) {
        this.selectedItemGroup = ''
      } else {
        this.selectedItemGroup = data.itemGroupId
      }
      if (data.itemSubGroupId === undefined) {
        this.selectedItemSubGroup = ''
      } else {
        this.selectedItemSubGroup = data.itemSubGroupId
      }
      this.selectedParentItem = data.parentID ? this.parentItemLists.find(a => a.id === data.parentID).id : null
      this.status = data.status
      this.id = data.id
      this.selectedUnitId = data.measurementId
      this.selectedVatType = data.vatType
      this.salesRate = data.salesRate
      this.minimumSalesRate = data.minimumSalesRate
      this.mrp = data.mrp
      this.purchaseRate = data.purchaseRate
      this.salesMargin = data.salesMarginPercentage
      this.discountPercentage = data.discountPercentage
      this.discount = data.discount
      this.openingQty = data.openingStock
      this.openingRate = data.openingRate
      this.wholesaleRate = data.wholesaleRate
      this.bonusItem = data.bonusItem
      this.serviceType = data.serviceType
      this.ccPercentage = data.ccPercentage
      this.isMultiUnit = data.multiUnit
      this.unitConversionData = data.itemMultiUnitDetailsDTOList
      this.qrCode = data.fullQrCode
      this.hsCode = data.hsCode
      if (data.warehouseId === undefined) {
        this.warehouseId = ''
      } else {
        this.warehouse = data.warehouseId
      }
      this.warehouse = data.warehouse
      this.warehouseDTOList = data.warehouseDTOList
      this.description = data.description
      if (data.imageList.length > 0) {
        this.imageList = data.imageList
        // this.url = data.imageList
      }
      this.selectItemSubgroup(this.selectedItemGroup.id)
      this.openBasic()
      this.backButton()
      this.loadParentItems()
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    openBasic() {
      this.displayBasic = true
      this.displayBasicRate = false
      this.displayOpeningDialog = false
    },
    closeBasic() {
      this.displayBasic = false
    },
    openOpening() {
      this.displayOpeningDialog = true
      this.displayBasic = false
      this.displayBasicRate = false
      this.resetOpeningDetails()
    },
    closeBasicRate() {
      this.displayBasicRate = false
      if (this.displayBasicView === true) {
        this.displayBasic = false
      } else {
        this.displayBasic = true
      }
      this.displayOpeningDialog = false
    },
    backButton() {
      this.displayBasicRate = false
      this.displayBasic = true
      this.displayOpeningDialog = false
    },
    openViewItem(data) {
      this.name = data.name
      this.code = data.itemCode
      if (data.itemGroupId === undefined) {
        this.selectedItemGroup = ''
      } else {
        this.selectedItemGroup = data.itemGroupId
      }
      if (data.itemSubGroupId === undefined) {
        this.selectedItemSubGroup = ''
      } else {
        this.selectedItemSubGroup = data.itemSubGroupId
      }
      this.status = data.status
      this.id = data.id
      this.selectedUnitId = data.measurementId
      this.selectedVatType = data.vatType
      this.salesRate = data.salesRate
      this.minimumSalesRate = data.minimumSalesRate
      this.mrp = data.mrp
      this.purchaseRate = data.purchaseRate
      this.salesMargin = data.salesMarginPercentage
      this.discountPercentage = data.discountPercentage
      this.discount = data.discount
      this.openingQty = data.openingStock
      this.openingRate = data.openingRate
      this.wholesaleRate = data.wholesaleRate
      this.bonusItem = data.bonusItem
      this.serviceType = data.serviceType
      this.ccPercentage = data.ccPercentage
      this.isMultiUnit = data.multiUnit
      this.unitConversionData = data.itemMultiUnitDetailsDTOList
      this.qrCode = data.fullQrCode
      if (data.warehouseId === undefined) {
        this.warehouseId = ''
      } else {
        this.warehouse = data.warehouseId
      }
      this.warehouse = data.warehouse
      this.warehouseDTOList = data.warehouseDTOList
      this.description = data.description
      if (data.imageList.length > 0) {
        this.imageList = data.imageList
      }
      this.displayBasicView = true
    },
    reset() {
      this.selectedItemSubGroup = ''
      this.selectedItemGroup = ''
      this.selectedVatType = ''
      this.selectedUnitId = ''
      this.qrCode = ''
      this.ccPercentage = 0.0
      this.bonusItem = false
      this.serviceType = false
      this.name = ''
      this.isMultiUnit = false
      this.multiUnitList = []
      this.unitConversionData = []
      this.images = []
      this.editing = false
      this.selectedParentItem = null
      this.warehouseDTOList = []
      this.unitConversionData = []
      this.resetOpeningDetails()
    },
    resetRateInfo() {
      this.salesRate = ''
      this.salesMargin = ''
      this.salesMarginPercentage = ''
      this.purchaseRate = ''
      this.mrp = ''
    },
    openBasicRate() {
      this.displayBasicRate = true
      this.displayBasic = false
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    addOpeningDetails() {
      if (this.warehouse === '' || this.warehouse === null) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select warehouse!', life: 10000})
        return
      }
      let warehouseDto = {
        id: this.warehouse.id,
        name: this.warehouse.name,
        openingRate: this.openingRate,
        openingStock: this.openingQty
      }
      if (this.openingQty <= 0) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Opening Quantity must be greater than zero!',
          life: 10000
        })
        return
      }
      if (this.openingRate <= 0) {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Opening Rate must be greater than zero!',
          life: 10000
        })
        return
      }
      if (!this.editDetails) {
        this.warehouseDTOList.push({...warehouseDto})
      } else {
        this.warehouseDTOList.splice(this.index, 1, {...warehouseDto})
      }
      this.resetOpeningDetails()
    },
    editOpeningDetails(data, index) {
      this.editDetails = true
      this.warehouse = {
        id: data.id,
        name: data.name
      }
      this.openingRate = data.openingRate
      this.openingQty = data.openingStock
      this.index = index
    },
    deleteOpeningdetails(data, index) {
      if (this.editing && data.id !== null) {
        // this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.warehouseDTOList.splice(index, 1)
    },
    resetOpeningDetails() {
      this.editDetails = false
      this.warehouse = ''
      this.openingRate = 0
      this.openingQty = 0
      this.openingAmount = 0
    },
    showItemUpload() {
      this.showItemUploadDialog = true
    },
    addUnitConversion() {
      let unitConversion = {
        unitFrom: this.unitFrom,
        unitTo: this.unitTo,
        unitFromValue: this.unitFromValue,
        unitToValue: this.unitToValue
      }
      this.unitConversionData.push({...unitConversion})
    },
    addUnitConversionFromList() {
      for (let i = 0; i < this.multiUnitList.length; i++) {
        let unitConversion = {
          id: this.multiUnitList[i].id,
          unitFrom: this.multiUnitList[i].unitFrom.shortName,
          unitTo: this.multiUnitList[i].unitTo.shortName,
          unitFromValue: this.multiUnitList[i].unitFromValue,
          unitToValue: this.multiUnitList[i].unitToValue,
          conversionId: this.multiUnitList[i].id
        }
        let found = this.unitConversionData.find(obj => obj.id === unitConversion.id)
        if (found === undefined) {
          this.unitConversionData.push({...unitConversion})
        }
      }
    },
    deleteUnitConversion(index) {
      this.unitConversionData.splice(index, 1)
      if (this.unitConversionData.length === 0) {
        this.multiUnitList = []
      }
    }
  },
  components: {
    Dropdown,
    Dialog,
    RadioButton,
    InputNumber,
    DataTable,
    Column,
    itemGroupDialog,
    itemSubGroupDialog,
    unitDialog,
    Carousel,
    Button,
    InputText,
    Textarea,
    MultiSelect,
    Checkbox
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
img.preview {
  max-width: 250px;
  max-height: 250px;
}.product-item {
}.product-item-content {
  border: 1px solid var(--surface-d);
  border-radius: 3px;
  margin: .3rem;
  text-align: center;
  padding: 2rem 0;
}.product-image {
  width: 50%;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}


</style>



// WEBPACK FOOTER //
// itemMasterDialog.vue?4fd94252